import React, { useState } from 'react';
import { Button, Dropdown, Icon, Tooltip } from 'antd';

import { ReactComponent as DocumentBellIcon } from '../../../resource/documents/DocumentBellIcon.svg';
import { CompanyDocumentReminderOverlay } from './CompanyDocumentReminderOverlay';

export const CompanyDocumentReminder = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Tooltip
        title="Напомнить"
        placement="left"
      >
        <Dropdown
          placement="bottomLeft"
          overlay={<CompanyDocumentReminderOverlay setVisible={setVisible} />}
          visible={visible}
          onVisibleChange={(visible) => setVisible(visible)}
          trigger={['click']}
        >
          <Button
            style={{
              marginRight: '10px',
              padding: 0,
              width: '32px',
              fontSize: '16px',
            }}
            className="ant-btn-icon-only"
          >
            <Icon component={DocumentBellIcon} />
          </Button>
        </Dropdown>
      </Tooltip>
    </>
  );
};
